module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/point_maedori_02@3x-8068b8e9732dd34c031f0744ac7a6746.webp";